import { render, staticRenderFns } from "./CardsView.vue?vue&type=template&id=6b54727b&scoped=true"
import script from "./CardsView.vue?vue&type=script&lang=js"
export * from "./CardsView.vue?vue&type=script&lang=js"
import style0 from "./CardsView.vue?vue&type=style&index=0&id=6b54727b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54727b",
  null
  
)

export default component.exports